import { render, staticRenderFns } from "./CaresManagement.vue?vue&type=template&id=98ddb7da&scoped=true&"
import script from "./CaresManagement.vue?vue&type=script&lang=js&"
export * from "./CaresManagement.vue?vue&type=script&lang=js&"
import style0 from "./CaresManagement.vue?vue&type=style&index=0&id=98ddb7da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98ddb7da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDataTable,VTextField})
